import { UseMutateFunction, useMutation } from '@tanstack/react-query';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getKpiAlertsExport, getKpiAlertsExportForRan } from '@api/kpiAlerts';

import {
	IKpiAlertExportDTO,
} from '@interfaces/kpi/dto/kpiAlertsDTO';

import { ESnackbarTypes, EVendorsValues } from '@enums/common';

import { KPI_ALERTS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useExportKpiAlerts(params: IKpiAlertExportDTO): {
	exportKpiAlerts: UseMutateFunction<Promise<void>, unknown, string, IKpiAlertExportDTO>;
	isLoading: boolean;
} {
	const dispatch = useAppDispatch();

	const exportFn = params.vendor === EVendorsValues.oran
		? getKpiAlertsExportForRan
		: getKpiAlertsExport;

	const {
		mutate,
		isLoading,
	} = useMutation<Promise<void>, unknown, string, IKpiAlertExportDTO>({
		mutationKey: [
			KPI_ALERTS_EXPORT,
			params,
		],
		mutationFn: (fileType: string) => exportFn(fileType, params),
		onSuccess: () => {
			params?.onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.error,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return {
		exportKpiAlerts: mutate,
		isLoading,
	};
}
